import React, { useEffect, useState } from 'react';
import { Link, Route, Routes, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import { useRecoilState, useRecoilValue } from 'recoil';
import { activeSideBarMenu, rolePermission } from '../recoil-store/recoil-state';
import { useRecoilActions } from '../recoil-store/recoil-actions';

// Shared Components
import Spinner from '../components/Spinner/Spinner';
import Sidebar from './layout/Sidebar/sidebar';
import Breadcrumb from './layout/Breadcrumb/breadcrumb';
// Pages
import Home from '../home/Home';
// Styles
import './shared.css';
import { SIDE_NAV_BAR_BOTTOM_ITEMS, SIDE_NAV_BAR_TOP_ITEMS } from "../services/MockData";

function Shared() {
    const [routeString, setRouteString] = useState(window.location.pathname.split('/').filter((x) => x));
    const [asm, setAsm] = useRecoilState(activeSideBarMenu);
    const [asmTemp, setAsmTemp] = useState({ ...asm });
    const permissions = useRecoilValue(rolePermission);
    const [loading, setLoading] = useState(true);
    const [sideBarOpen, setSideBarOpen] = useState(false);
    const actions = useRecoilActions();
    const location = useLocation();
    const history = useNavigate();

    useEffect(() => {
        let path = SIDE_NAV_BAR_TOP_ITEMS.find(x => x.name === routeString[0]);
        if (!path) path = SIDE_NAV_BAR_BOTTOM_ITEMS.find(x => x.name === routeString[0]);
        if (path && path.order) {
            asmTemp.parent = path.order;
            let secondPath;
            if (path.hasOwnProperty('subItems')) {
                secondPath = path.subItems.find(x => x.name === routeString[1]);
            } else if (path.hasOwnProperty('thirdLevelItems')) {
                secondPath = path.thirdLevelItems.find(x => x.name === routeString[1]);
            }
            //const secondPath = path.hasOwnProperty('subItems') ? path.subItems.find(x => x.name === routeString[1]) : path.thirdLevelItems.find(x => x.name === routeString[1]);

            if (secondPath && secondPath.order) {
                asmTemp.child = secondPath.order;
                const thirdPath = secondPath.hasOwnProperty('subItems') ? secondPath.subItems.find(x => x.name === routeString[2]) : secondPath.thirdLevelItems?.find(x => x.name === routeString[2]);
                if (thirdPath && thirdPath.order) {
                    asmTemp.thirdChild = thirdPath.order;
                } else {
                    asmTemp.thirdChild = 0;
                }
            } else {
                asmTemp.child = 0;
            }
        } else {
            asmTemp.parent = 0;
            asmTemp.child = 0;
            asmTemp.thirdChild = 0;
        }

        setAsm(asmTemp);
    }, []);

    useEffect(() => {
        let ls = localStorage.getItem('authToken');
        if (!ls) {
            history('/login?to=' + location.pathname);
        } else {
            fetchData().then(r => r);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchData = async () => {
        actions.connection();
        await actions.getLicensePermission();
        await actions.getPersonalization();
        await actions.getRolePermission();
        await actions.setBaseOriginForImage();
        setLoading(false);
    };

    return (
        <div style={{ height: '100%' }}>
            {loading ?
                <div className="loading-container"><Spinner /></div> :
                permissions?.status ? (
                    <div id="shared-container">
                        {/*<Navbar />*/}
                        <Sidebar sideBarOpen={sideBarOpen} setSideBarOpen={setSideBarOpen} asm={asmTemp} />
                        {!(window.location.pathname === "/" || window.location.pathname === "/dashboard/panel") &&
                            <Breadcrumb sideBarOpen={sideBarOpen} />}
                        <Grid container id="home-container">
                            <Routes>
                                <Route path="/*" element={<Home asm={asmTemp} />} />
                            </Routes>
                        </Grid>
                    </div>
                )
                    :
                    (<div className="loading-container">
                        <Navigate to={`/login?to=${location.pathname}`} />
                        Permissions Not Found
                        <Link to="/login">
                            Back to Login
                        </Link>
                    </div>)
            }
        </div>
    );
}

export default Shared;
